export enum ViewEntityType {
  NONE = "NONE",
  FASCIA = "FASCIA",
  EAVE_FASCIA = "EAVE_FASCIA",
  EAVE_SOFFIT = "EAVE_SOFFIT",
  FASCIA_TRIM = "FASCIA_TRIM",
  RAFTER_EXTENSION = "RAFTER_EXTENSION",
  BOX_EAVE = "BOX_EAVE",
  MINI_HIP_EAVE = "MINI_HIP_EAVE",
  MINI_HIP_ROOF = "MINI_HIP_ROOF",
  MINI_SHED_EAVE = "MINI_SHED_EAVE",
  MINI_SHED_ROOF = "MINI_SHED_ROOF",
  WINDOW_EXTERIOR_TRIM = "WINDOW_EXTERIOR_TRIM",
  DOOR_EXTERIOR = "DOOR_EXTERIOR",
  GABLE_ROOF_VENT = "GABLE_ROOF_VENT",
  PROFILE_EXTRUSION = "PROFILE_EXTRUSION",
  COLUMN = "COLUMN",
  COLUMN_BRACKET = "COLUMN_BRACKET",
  PORCH_RAILING = "PORCH_RAILING",
  PORCH_HEADER = "PORCH_HEADER",
  PORCH_HEADER_TRIM = "PORCH_HEADER_TRIM",
  RAILING = "RAILING",
  STAIR_RUN = "STAIR_RUN",
  AWNING = "AWNING",
  AWNING_BRACKET = "AWNING_BRACKET",
  APRON_CASING = "APRON_CASING",
  HEAD_CASING = "HEAD_CASING",
  SIDE_CASING = "SIDE_CASING",
  STOOL_CASING = "STOOL_CASING",
  SITE_SHAPE = "SITE_SHAPE",
  WINDOW = "WINDOW",
  SHUTTER = "SHUTTER",
  DOOR = "DOOR",
  WAINSCOTING = "WAINSCOTING",
  WAINSCOTING_CAP = "WAINSCOTING_CAP",
  PROP = "PROP",
  OUTSIDE_CORNER = "OUTSIDE_CORNER",
  INSIDE_CORNER = "INSIDE_CORNER",
  DORMER_CORNER = "DORMER_CORNER",
  WALL_ROOF_BASEBOARD = "WALL_ROOF_BASEBOARD",
}
